import { render } from "./Banner.vue?vue&type=template&id=9f7d905e&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=9f7d905e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9f7d905e"

export default script